import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage, FormattedNumber, injectIntl, intlShape } from 'react-intl';
import { Spinner } from 'shared-components/decorators/spinner';

const ApplyCreditField = ({
  value,
  input = {},
  className,
  inputClassName,
  attributes = {},
  errorMessage = '',
  meta = {},
  showErrorOnChange = false,
  creditBalance = 0,
  creditsApplied = 0,
  currency = 'USD',
  isProcessing = false,
  partialPayMethod = false,
  intl
}) => {
  const { error, submitFailed, touched } = meta;
  const checkboxFieldClassNames = classNames('CheckboxField apply-credit-field', className);
  const showError = !!((error && submitFailed) || (error && showErrorOnChange && touched));
  const creditLabel = input.value
    ? intl.formatMessage({ id: 'inbox_guest_update_booking.apply_credit_field.remove', defaultMessage: 'Remove' })
    : intl.formatMessage({ id: 'inbox_guest_update_booking.apply_credit_field.apply_credits', defaultMessage: 'Apply credits' });

  return (
    isProcessing ? <div className="credit-spinner-container margin-md-top"><Spinner additionalStyle="gray" /></div>
      : <div className={checkboxFieldClassNames}>
        { input.value && !partialPayMethod ?
          <span className="text-gray-dark" data-testing-id='credit-balance'>
            <FormattedMessage
              id="inbox_guest_update_booking.apply_credit_field.applied_credits"
              defaultMessage="Applied {credits} to your booking"
              values={{
                credits: <FormattedNumber value={creditsApplied} currency={currency} style={'currency'}/>
              }}
            />
          </span>
          : <span className="text-gray-dark" data-testing-id='credit-balance'>
            <FormattedMessage
              id="inbox_guest_update_booking.apply_credit_field.your_balance"
              defaultMessage="Your credit balance: {balance}"
              values={{
                balance: <FormattedNumber value={creditBalance} currency={currency} style={'currency'} />
              }}
            />&nbsp;
          </span>
        }

        {
          !partialPayMethod && <input
            {...input}
            type="checkbox"
            id="apply-credit"
            className={classNames('custom-control-input', inputClassName)}
            {...(value && { value })}
            {...attributes}
            {...(input.value && { defaultChecked: input.value })}
          />
        }
        {!partialPayMethod && (
          <label
            data-testing-id='credit-label'
            className="credit-label link-span margin-md-left no-bottom-margin" htmlFor="apply-credit"
          >
            { creditLabel }
          </label>
        )}

        {partialPayMethod &&
          <div className="text-gray-dark">
            <FormattedMessage
              id='inbox_guest_update_booking.apply_credit_field.part_now_part_later_info'
              defaultMessage='Credits cannot be used with our Pay part now, part later feature.'
            />
          </div>}
        {
          showError && (
            <p className="error text-danger text-small">
              {errorMessage || error}
            </p>
          )
        }
      </div>
  );
};

ApplyCreditField.propTypes = {
  errorMessage: PropTypes.string,
  meta: PropTypes.object,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  id: PropTypes.string.isRequired,
  value: PropTypes.string,
  input: PropTypes.object,
  attributes: PropTypes.object,
  showErrorOnChange: PropTypes.bool,
  creditBalance: PropTypes.string,
  currency: PropTypes.string,
  isProcessing: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(ApplyCreditField);
